import CTA13 from './CTA13'
export default CTA13
